import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ComingSoonComponent} from './coming-soon.component';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';

const routes: Routes = [
  {
    path: '',
    component: ComingSoonComponent,
    data: {
      activeLink: ToolbarButton.COMING_SOON
    },
    title: 'Coming Soon',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComingSoonRoutingModule {
}
